import {
  LOAD_COMPANY_INFO,
  LOAD_COMPANY_INFO_SUCCESS,
  LOAD_COMPANY_INFO_FAIL,
  CompanyInfoActions,
  CompanyInfo
} from '../actions/company-info.action';

export interface ICompanyInfoState {
  companyInfo: CompanyInfo | null;
  loading: boolean;
  loaded: boolean;
}

export const initialState: ICompanyInfoState = {
  companyInfo: null,
  loading: false,
  loaded: false
};

export function companyInfoReducer(state = initialState, action: CompanyInfoActions): ICompanyInfoState {
  switch (action.type) {
    case LOAD_COMPANY_INFO: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }

    case LOAD_COMPANY_INFO_SUCCESS: {
      return {
        ...state,
        companyInfo: action.payload,
        loading: false,
        loaded: true
      };
    }

    case LOAD_COMPANY_INFO_FAIL: {
      return {
        ...state,
        companyInfo: null,
        loading: false,
        loaded: false
      };
    }

    default: {
      return state;
    }
  }
}